import axios from "axios";

const forms = document.querySelectorAll('[data-bonus-form]');
forms.forEach((form) => {
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        sendForms([form]);
    })
});

function toggleClassForm(form, className) {
    form.classList.add(className);
    setTimeout(() => {
        form.classList.remove(className);
    }, 1000);
}

function sendForms(forms) {
    let promises = [];
    forms.forEach((form) => {
        const formData = new FormData(form);
        form.classList.add('_pending');
        promises.push(axios({
            url: '/marketplace/admin/bonuses/set/value',
            method: 'post',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        }).then(response => {

        }).catch(response => {
            toggleClassForm(form, '_error');
        }))
    });
    Promise.all(promises).then(() => {
        forms.forEach((form) => {
            form.classList.remove('_pending');
            toggleClassForm(form, '_success');
        })
    });
}